import React, { ComponentPropsWithoutRef, useCallback } from 'react';
import { useTranslation } from '@rbx/intl';
import useSideBarContent from '@modules/ui/shared/hooks/useSideBarContent';
import { useNavigationConfigs } from '@rbx/creator-hub-navigation';
import { getTranslatedReferenceNodeId } from '@modules/apiReference/page/utils/sidebar';
import { ReferenceType } from '@modules/client/types/globalTypes';
import EngineReferenceLandingTabs from '@modules/apiReference/landing/EngineReferenceLandingTabs';
import { useAppConfig } from '@modules/layout/layout/components/AppConfigProvider';

type DivProps = ComponentPropsWithoutRef<'div'>;
export interface SideBarLinkProps extends DivProps {
  nodeId: string;
}

const referenceTypeToKey: Record<string, ReferenceType> = {
  'Engine API/Classes': ReferenceType.CLASS,
  'Engine API/Data Types': ReferenceType.DATATYPE,
  'Engine API/Enums': ReferenceType.ENUM,
  'Engine API/Globals': ReferenceType.GLOBAL,
  'Engine API/Libraries': ReferenceType.LIBRARY,
};

export default function SideBarLink({ nodeId, children, ...otherProps }: SideBarLinkProps) {
  const { setExpanded, setOpen, expanded } = useSideBarContent();
  const { toggleProductNavigationDrawer } = useNavigationConfigs();
  const { translate } = useTranslation();
  const { enableEngineReferenceRevamp } = useAppConfig();

  const translatedNodeId = getTranslatedReferenceNodeId(nodeId, translate);

  const clickHandler = useCallback(() => {
    toggleProductNavigationDrawer(true);
    setOpen(true);
    if (expanded.includes(translatedNodeId)) {
      setExpanded(expanded.filter((id) => id !== translatedNodeId));
    } else {
      setExpanded([translatedNodeId, ...expanded]);
    }
  }, [translatedNodeId, setExpanded, setOpen, toggleProductNavigationDrawer, expanded]);

  if (enableEngineReferenceRevamp) {
    return <EngineReferenceLandingTabs referenceType={referenceTypeToKey[nodeId]} />;
  }

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    <div {...otherProps} onClick={clickHandler}>
      {children}
    </div>
  );
}
